import type { HighlighterProps } from 'react-highlight-words';
import Highlighter from 'react-highlight-words';
import type { StyledComponent } from 'styled-components';
import styled from 'styled-components';

export const StyledHighlighter: StyledComponent<typeof Highlighter, HighlighterProps> = styled(
  Highlighter,
)`
  .mark-highlight {
    padding: 0;
    background-color: #eaff8f;
  }
`;
